<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import { LanguageIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
    dataCurrentLanguage: {
        type: String,
        default: 'en'
    },
    dataStyle: {
        type: String,
        default: 'guest'
    }
})

function isGuest() {
    return props.dataStyle === 'guest'
}

function isMember() {
    return props.dataStyle === 'member'
}

let links = [
    {
        key: 'kl',
        name: 'Kalaallisut',
        url: '/language/kl'
    },
    {
        key: 'da',
        name: 'Dansk',
        url: '/language/da'
    },
    {
        key: 'en',
        name: 'English',
        url: '/language/en'
    },
    {
        key: 'fo',
        name: 'Føroyskt',
        url: '/language/fo'
    }
]

</script>

<template>
    <Menu as="div" class="md:inline-block relative text-left">
        <div>
            <MenuButton :class="{ 'text-white': isGuest(), 'hover:text-gray-900': isGuest(), 'hover:bg-gray-50': isGuest(), 'text-black': isMember(), 'hover:bg-white': isMember() }" class="group inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm font-semibold">
                <language-icon :class="{ 'text-white': isGuest(), 'group-hover:text-gray-900': isGuest() }" class="h-5 w-5" aria-hidden="true" />
                <span v-if="dataCurrentLanguage === 'kl'">
                    Kalaallisut
                </span>
                <span v-else-if="dataCurrentLanguage === 'da'">
                    Dansk
                </span>
                <span v-else-if="dataCurrentLanguage === 'en'">
                    English
                </span>
                <span v-else-if="dataCurrentLanguage === 'fo'">
                    Føroyskt
                </span>
                <ChevronDownIcon :class="{ 'text-white': isGuest(), 'group-hover:text-gray-900': isGuest() }" class="-mr-1 h-5 w-5" aria-hidden="true" />
            </MenuButton>
        </div>

        <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
            <MenuItems class="absolute right-0 z-50 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div class="py-1">
                    <MenuItem  v-for="link in links"
                               :key="link.key"
                               :href="link.url"
                               :class="link.key === dataCurrentLanguage ? 'bg-gray-100 text-gray-900' : 'text-gray-700'"
                               class="block px-4 py-2 text-sm hover:bg-gray-200"
                               as="a"
                    >
                        {{ link.name }}
                    </MenuItem>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>


